import { ref } from 'vue';
import axios from 'axios';
const getUserTypes = () => {
    const user_types = ref([]);
    const error = ref('');
    try {
        const loadUserTypes = async () => {
            await axios
                .get(axios.defaults.baseUrl + "getUserTypes",
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('auth_token'),
                        },
                    }
                )
                .then((response) => {
                    user_types.value = response.data;
                })
                .catch((error) => {
                    error.value = 'No User Type Found';
                });
        }
        return { user_types, error, loadUserTypes };
    } catch (error) {
        error.value = 'No User Type Found';
    }
}
export default getUserTypes;